<template>
    <SJMMall>
        <div class="batchPicking">
            <!-- 主体 -->
            <div class="container">
                <!-- 站点面包屑导航 -->
                <div class="siteNav">
                    <SiteNav :siteNavList="siteNavList"></SiteNav>
                </div>
               
                <!-- 搜索栏 -->
                <div class="batchPicking-container">
                    <div class="searchWrap">
                        <el-button type="primary" 
                                   style="font-size: 14px; background: #409eff; border-color: #409eff;"
                                   icon="el-icon-plus"
                                   size="medium"
                                   @click="planDialogVisible = true;getplanList()" 
                                        
                        >{{$t('message.ICRbatchpicking')}}</el-button>
                        <el-button type="primary" 
                                   style="font-size: 14px; background: rgba(244, 176, 28, 1); border-color: rgba(244, 176, 28, 1);"
                                   icon="el-icon-plus"
                                   size="medium"
                                   @click="shwoaccurate = true" 
                                        
                        >{{$t('message.Iaccurately')}}</el-button>
                        
                    </div>
                    


                    <el-dialog title=""
                               :visible.sync="modifyVisible"
                               :close-on-click-modal="false"
                               :width="!$isZh() ? '540px' : '340px'"
                               class="modmodal"
                               @close="modifyItem = {   pickupRemarks: '',
                                                        pickupLicensePlate: '',
                                                        pickupName: '',
                                                        pickupDate: '',
                                                        pickupPhone: ''}"
                    >
                        <span slot="footer" 
                              class="dialog-footer">                       
                            <el-button type="primary"                                       
                                       @click="submitmodify()">{{$t('message.queding')}}</el-button>
                        </span> 
                        <div class="mody"><span>{{$t('message.pickupDate')}}</span><el-date-picker  v-model="modifyItem.pickupDate"
                                                                                                    type="date"
                                                                                                    style="width: 200px;"
                                                                                                    :picker-options="myDate"
                                                                                                    :placeholder="$t('message.selectDate')"
                                                                                                    format="yyyy-MM-dd"
                                                                                                    :clearable="false">
                        </el-date-picker>
                            
                        </div>    
                        <div class="mody"><span>{{$t('message.IFlatenumbe')}}</span><el-input v-model.trim="modifyItem.pickupLicensePlate" 
                                                        
                                                                                              style="width: 200px;"
                                                                                              @blur="emailBlurInspect"></el-input>
                        </div>
                        <div class="mody"><span>{{$t('message.Iconsignee')}}</span><el-input v-model.trim="modifyItem.pickupName" 
                                                        
                                                                                             style="width: 200px;"></el-input>
                        </div>    
                        <div class="mody"><span>{{$t('message.Itelephone')}}</span><el-input v-model.trim="modifyItem.pickupPhone" 
                                                        
                                                                                             style="width: 200px;"></el-input>
                        </div>
                        <div class="mody"><span>{{$t('message.remark')}}</span><el-input v-model.trim="modifyItem.pickupRemarks" 
                                                        
                                                                                         style="width: 200px;"></el-input>
                        </div>                                            
                                      
                    </el-dialog>   
                    <el-dialog :title="$t('message.Iwarehousing')"
                               :visible.sync="waerhouseDialogVisible"
                               :close-on-click-modal="false"
                               width="420px"
                               @close="customsWarehouseType = '';second = false;actItem = {};isaccurate = false;first = false" 
                    >
                        <span slot="footer" 
                              class="dialog-footer">                       
                            <el-button type="primary" 
                                       :disabled="!customsWarehouseType"
                                       @click="submitWare()">{{$t('message.queding')}}</el-button>
                        </span> 
                        <el-radio v-model="customsWarehouseType" label="1">{{$t('message.Inoreturn')}}</el-radio>
                        <el-radio v-model="customsWarehouseType" label="2">{{$t('message.Icustoms')}}</el-radio>
                        <el-radio v-model="customsWarehouseType" label="3">物流留场货（102库普货）</el-radio>
                        <el-radio v-model="customsWarehouseType" label="4">物流留场货（102库危险品）</el-radio>
                    </el-dialog>
                    <el-dialog :title="titlePlan"
                               :visible.sync="planDialogVisible"
                               :close-on-click-modal="false"
                               :width="isCreat ? '1100px' : '900px'"
                               @close="initplanList()">
                        <span v-if="orderBillList.length > 0 || orderBillList1.length > 0" 
                              slot="footer" 
                              class="dialog-footer">                       
                            <el-button type="primary" @click="submitAddPlan()">{{$t('message.queding')}}</el-button>
                        </span>
                        <template v-if="!isCreat">
                            <span style="margin-right: 10px; font-size: 15px; font-weight: 500; line-height: 28px; color: rgba(53, 53, 53, 1);">{{$t('message.IFwaybill')}}</span>
                            <el-input v-model.trim="drCodeNumber"                                   
                                      class="conditionInput arrivalDate"
                                      style="width: 150px;"></el-input>  
                            <el-button type="primary"
                                       style="margin-left: 10px;"
                                       @click="filetrOrderBillList()">{{$t('message.query')}}</el-button>  
                        </template>    
                        
                        <div class="plan-data" style="max-height: 600px; margin-top: 0; overflow: auto;">
                            <SJMLoading v-if="planDialogLoading"
                                        :type="loadingType" 
                                        :backgroundColor="loadingBackgroundColor"
                                        zIndex="11"></SJMLoading>
                            <div v-if="!planDialogLoading && orderBillList.length === 0 && orderBillList1.length ===0">
                                <img :style="{margin:isCreat ? '20px 0 20px 420px' : '20px 0 20px 320px',width : '300px'}"
                                     src="../../../../../assets/img/personalCenter/operationCenter/cargoQuery/importBusiness/zaEmpty.png"/>
                                <p style="text-align: center;">{{$t('message.noData')}}</p>     
                            </div> 
                               
                            <table v-if="orderBillList.length > 0 || orderBillList1.length > 0" class="orderBillList">
                                <tr>
                                    <th>                               
                                        <!-- 未完成 -->
                                        <div class="titleBox" style="color: rgba(53, 53, 53, 1);">
                                            <div class="tit" style="width: 40px;"></div>
                                            <div class="tit" style="width: 160px;">{{$t('message.waybillNumber')}}</div>
                                            <div class="tit" style="width: 160px;">{{$t('message.minorBillCode')}}</div>
                                            <div class="tit" style="width: 135px;">{{$t('message.pieces')}}</div>
                                            <div class="tit" style="width: 135px;">{{$t('message.weight')}}</div>                                      
                                            <div v-if="isCreat" 
                                                 class="tit" 
                                                 style="width: 160px;">{{$t('message.Igoodstype')}}</div>
                                            <div class="tit" :style="{width: !$isZh() ? '168px' : '160px'}">{{$t('message.IOPwarehouse')}}</div>                                   
                                        </div>
                                    </th>
                                </tr>
                                <template v-if="isCreat">
                                    <tr v-for="(item,index) in orderBillList"
                                        :key="index"
                                        class="contentTr"
                                    >
                                        <td>     
                                            <div class="strip" 
                                                 :style="{borderColor: 'rgba(170, 170, 170, 1)',color: (cargoType && (item.cargoType !== cargoType || item.operationWarehouse !== operationWarehouse)) ? '#AAAAAA' : '#3D3A39'}">   
                                                <div class="stripItem"                                               
                                                     style="justify-content: flex-end; width: 40px;">
                                                    <el-checkbox v-model="item.checked"                                                         
                                                                 :disabled="(cargoType && (item.cargoType !== cargoType || item.operationWarehouse !== operationWarehouse)) ? true :false"
                                                                 @change="changeChecked(item)"></el-checkbox>
                                                </div>                                   
                                                <div class="stripItem" style="width: 160px;">{{item.drCode}}</div>
                                                <div class="stripItem" style="width: 160px;">{{item.houseBlCode}}</div>
                                                <div class="stripItem" style="width: 135px;">{{item.pieces}}</div>
                                                <div class="stripItem" style="width: 135px;">{{item.weight}}</div>                                    
                                                <div class="stripItem" 
                                                     style="width: 160px;">{{cargoTypeMeath(item.cargoType)}}</div>
                                                <div class="stripItem" 
                                                     :style="{width: '160px',color: (cargoType && (item.cargoType !== cargoType || item.operationWarehouse !== operationWarehouse)) ? '#AAAAAA' : 'rgba(244, 176, 28, 1)'}">{{item.operationWarehouse}}</div>                                                      
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr v-for="(item,index) in orderBillList1"
                                        :key="index"
                                        class="contentTr"
                                    >
                                        <td>                                    
                                            <div class="strip" 
                                                 :style="{borderColor: 'rgba(170, 170, 170, 1)',color: '#3D3A39'}">   
                                                <div class="stripItem"                                               
                                                     style="justify-content: flex-end; width: 40px;">
                                                    <el-checkbox v-model="item.checked"                                                         
                                                                 @change="changeChecked1(item)"></el-checkbox>
                                                </div>                                   
                                                <div class="stripItem" style="width: 160px;">{{item.drCode}}</div>
                                                <div class="stripItem" style="width: 160px;">{{item.houseBlCode}}</div>
                                                <div class="stripItem" style="width: 135px;">{{item.pieces}}</div>
                                                <div class="stripItem" style="width: 135px;">{{item.weight}}</div>                                    
                                                <div class="stripItem" style="width: 160px; color: rgba(244, 176, 28, 1);">{{item.operationWarehouse}}</div>                                                      
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                
                                   
                                
                            </table>
                             
                        </div>       
                        
                    </el-dialog>
                    
                    <div v-if="shwoaccurate" 
                         class="plan-data"  
                         style="min-height: auto;"> 
                        <div style="padding: 20px; margin: 0 20px 20px 20px; box-shadow: 0 2px 5px 2px rgba(213, 213, 213, 0.5);">
                            <div class="searchWrap" style="padding-top: 0; margin-left: 0;">
                                <span style="margin-right: 10px; font-size: 15px; font-weight: 500; line-height: 28px; color: rgba(53, 53, 53, 1);">{{$t('message.IFwaybill')}}</span>
                                <el-input v-model.trim="drCode"
                                          :placeholder="$t('message.Ienter8')"
                                          maxlength="8"
                                          :style="{width: !$isZh() ? '250px' : '130px'}"
                                          class="conditionInput arrivalDate"></el-input>
                                
                            </div>
                            <table v-if="accurateOrderBillList.length > 0" class="orderBillList">
                                <tr>
                                    <th>
                                        <!-- 未完成 -->
                                        <div class="titleBox" style="color: rgba(53, 53, 53, 1);">
                                            <div class="tit" style="width: 160px;">{{$t('message.waybillNumber')}}</div>
                                            <div class="tit" style="width: 160px;">{{$t('message.minorBillCode')}}</div>
                                            <div class="tit" style="width: 135px;">{{$t('message.pieces')}}</div>
                                            <div class="tit" style="width: 135px;">{{$t('message.weight')}}</div>                                      
                                            <div class="tit" style="width: 160px;">{{$t('message.Igoodstype')}}</div>
                                            <div class="tit" style="width: 160px;">{{$t('message.IOPwarehouse')}}</div>
                                            <div class="tit" style="width: 100px;">{{$t('message.operate')}}</div>
                                        </div>
                                    </th>
                                </tr>
                                <tr v-for="(item,index) in accurateOrderBillList"
                                    :key="index"
                                    class="contentTr"
                                >
                                    <td>
                                        <div class="strip">                                      
                                            <div class="stripItem" style="width: 160px;">{{item.drCode}}</div>
                                            <div class="stripItem" style="width: 160px;">{{item.houseBlCode}}</div>
                                            <div class="stripItem" style="width: 135px;">{{item.pieces}}</div>
                                            <div class="stripItem" style="width: 135px;">{{item.weight}}</div>                                    
                                            <div class="stripItem" style="width: 160px;">{{cargoTypeMeath(item.cargoType)}}</div>
                                            <div class="stripItem" style="width: 160px;">{{item.operationWarehouse}}</div>     
                                            <div class="stripItem" style="width: 100px;">
                                                <el-button type="primary" @click="addaccurateOrder(item.orderBillCode)">{{$t('message.Iadding')}}</el-button>                                        
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <div v-if="accurateOrderBillList1.length > 0" 
                                 style="margin-bottom: 10px; color: rgba(53, 53, 53, 1);">{{$t('message.Iadded')}}</div>
                            <div v-if="accurateOrderBillList1.length > 0" 
                                 style="padding: 20px; font-size: 15px; font-weight: 500; border: 1px solid #979797;">
                                <table class="orderBillList">
                                    <tr>
                                        <th>
                                            <!-- 未完成 -->
                                            <div class="titleBox" style="color: rgba(53, 53, 53, 1);">
                                                <div class="tit" style="width: 160px;">{{$t('message.waybillNumber')}}</div>
                                                <div class="tit" style="width: 160px;">{{$t('message.minorBillCode')}}</div>
                                                <div class="tit" style="width: 135px;">{{$t('message.pieces')}}</div>
                                                <div class="tit" style="width: 135px;">{{$t('message.weight')}}</div>                                      
                                                <div class="tit" style="width: 160px;">{{$t('message.Igoodstype')}}</div>
                                                <div class="tit" style="width: 160px;">{{$t('message.IOPwarehouse')}}</div>
                                                <div class="tit" style="width: 100px;">{{$t('message.operate')}}</div>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr v-for="(item,index) in accurateOrderBillList1"
                                        :key="index"
                                        class="contentTr"
                                    >
                                        <td>
                                            <div class="strip">                                      
                                                <div class="stripItem" style="width: 160px;">{{item.drCode}}</div>
                                                <div class="stripItem" style="width: 160px;">{{item.houseBlCode}}</div>
                                                <div class="stripItem" style="width: 135px;">{{item.pieces}}</div>
                                                <div class="stripItem" style="width: 135px;">{{item.weight}}</div>                                    
                                                <div class="stripItem" style="width: 160px;">{{cargoTypeMeath(item.cargoType)}}</div>
                                                <div class="stripItem" style="width: 160px;">{{item.operationWarehouse}}</div>     
                                                <div class="stripItem" style="width: 100px;">
                                                    <img style="width: 20px; height: 21px; cursor: pointer;" 
                                                         src="../../../../../assets/img/personalCenter/operationCenter/cargoQuery/importBusiness/deletePlan.png"
                                                         @click="deleteacc(index)">                                        
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                                <div style="display: flex; justify-content: flex-end;">
                                    <el-button v-if="accurateOrderBillList1.length > 0" 
                                               type="primary" 
                                               @click="submitAccurateOrder()">{{$t('message.confirm')}}</el-button>   
                                </div>
                                
                            </div>
                        </div>
                        
                    </div>
                    
                    <div v-if="orderBillListLoading || pickupPlanList.length > 0"
                         class="plan-data"
                         style="padding-bottom: 1px;"> 
                        <div v-for="(v,i) in pickupPlanList" 
                             :key="i"
                             style="padding: 20px; margin: 0 20px 20px 20px; background: #deedff;">
                            <div style="position: relative; display: flex; padding: 15px; font-size: 16px; color: rgba(53, 53, 53, 1); background: #fff;">
                                <div style="max-width: 380px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"><span>{{$t('message.Iplatenumber')}}:{{'\u00a0\u00a0\u00a0'}}</span>
                                    <el-popover placement="top"
                                                title=""
                                                width="280"
                                                trigger="hover"
                                                :content="v.pickupLicensePlate || $t('message.ICARdetermined')">
                                                
                                        <span slot="reference" :style="{color:v.pickupLicensePlate ? 'unset' : 'rgba(170, 170, 170, 1)',cursor:'po'}">{{v.pickupLicensePlate || $t('message.ICARdetermined')}}</span>

                                    </el-popover>    
                                </div>
                                <div style="margin-left: 38px;"><span>{{$t('message.Idrivername')}}:{{'\u00a0\u00a0\u00a0'}}</span><span :style="{color:v.pickupLicensePlate ? 'unset' : 'rgba(170, 170, 170, 1)'}">{{v.pickupName || $t('message.Idetermined')}}</span></div>
                                <div style="margin-left: 38px;"><span>{{$t('message.pickupDate')}}:{{'\u00a0\u00a0\u00a0'}}</span>{{v.pickupDate ? $moment(Number(v.pickupDate)).format('YYYY-MM-DD') : '--'}}</div>
                                <img style="position: absolute; top: 15px; right: 15px; width: 20px; height: 21px; cursor: pointer;" 
                                     src="../../../../../assets/img/personalCenter/operationCenter/cargoQuery/importBusiness/beifen.png"
                                     @click="modify(v)" />
                            </div>
                            <table class="orderBillList">
                                <tr>
                                    <th>
                                        <!-- 未完成 -->
                                        <div class="titleBox" style="color: rgba(53, 53, 53, 1);">
                                            <div v-if="v.paymentStatus"
                                                 class="tit" 
                                                 style="justify-content: flex-end; width: 62px;"></div>
                                            <div class="tit" style="width: 160px;">{{$t('message.waybillNumber')}}</div>
                                            <div class="tit" style="width: 160px;">{{$t('message.minorBillCode')}}</div>
                                            <div class="tit" :style="{width: v.paymentStatus ? '120px' : '135px'}">{{$t('message.pieces')}}</div>
                                            <div class="tit" :style="{width: v.paymentStatus ? '120px' : '135px'}">{{$t('message.weight')}}</div>                                      
                                            <div class="tit" style="width: 160px;">{{$t('message.Igoodstype')}}</div>
                                            <div class="tit" style="width: 160px;">{{$t('message.IOPwarehouse')}}</div>
                                            <div class="tit" style="width: 120px;">{{$t('message.Ilatestpicking')}}</div>
                                            <div class="tit" style="width: 100px;">{{$t('message.operate')}}</div>
                                        </div>
                                    </th>
                                </tr>
                                <tr v-for="(item,index) in v.orderBillList"
                                    :key="index"
                                    class="contentTr"
                                >
                                    <td>
                                        <div class="strip">                                            
                                            <div v-if="v.paymentStatus"
                                                 class="stripItem" 
                                                 style="justify-content: flex-end; width: 62px; color: #e71a40;">{{item.paymentStatus === '0' ? $t('message.waitPay') : ''}}</div>                                    
                                            <div class="stripItem" style="width: 160px;">{{item.drCode}}</div>
                                            <div class="stripItem" style="width: 160px;">{{item.houseBlCode ? item.houseBlCode : '--'}}</div>
                                            <div class="stripItem" :style="{width: v.paymentStatus ? '120px' : '135px'}">{{item.pieces ? item.pieces : '--'}}</div>
                                            <div class="stripItem" :style="{width: v.paymentStatus ? '120px' : '135px'}">{{item.weight ? item.weight : '--'}}</div>                                    
                                            <div class="stripItem" style="width: 160px;">{{cargoTypeMeath(item.cargoType)}}</div>
                                            <div class="stripItem" style="width: 160px;">{{item.operationWarehouse}}</div>
                                            <div class="stripItem" style="width: 120px;">{{item.pickupDeadLine ? $moment(Number(item.pickupDeadLine)).format('YYYY-MM-DD') : '--'}}</div>                         
                                            <div class="stripItem" style="width: 100px;">
                                                <img style="width: 20px; height: 21px; cursor: pointer;" 
                                                     src="../../../../../assets/img/personalCenter/operationCenter/cargoQuery/importBusiness/deletePlan.png"
                                                     @click="deletePlan(item.orderBillCode)">                                        
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <div style="margin-top: 10px; font-size: 16px; color: rgba(53, 53, 53, 1);">{{$t('message.ItotalWeight')}}：{{v.totalWeight}}</div>
                            <div style="display: flex; justify-content: space-between; margin-top: 10px; font-size: 16px;">
                                <div><el-button type="primary"                                              
                                                icon="el-icon-plus"                                              
                                                circle
                                                @click="addTihuo(v)"></el-button><span style="margin-left: 10px;">{{$t('message.Iaddingpicking')}}</span></div>
                                <el-button type="primary" @click="goPage(v)">
                                    {{$t('message.confirm')}}
                                </el-button>
                            </div>
                        </div>
                        
                        <SJMLoading v-if="orderBillListLoading" zIndex="11"></SJMLoading>
                    </div>
                    <div v-if="!orderBillListLoading && pickupPlanList.length === 0">
                        <img style="width: 300px; margin: 90px 500px 30px 520px;"
                             src="../../../../../assets/img/personalCenter/operationCenter/cargoQuery/importBusiness/zaEmpty.png"/>
                        <p style="text-align: center;">{{$t('message.noData')}}</p>     
                    </div>
                    
                </div>
                
                
            </div>
        </div>
        <UploadFile :show="uploadFileVisible"
                    type="1"
                    uploadType="051"
                    @save="saveUploadFiles"></UploadFile>
    </SJMMall>
</template>
<script>
   
    import UploadFile from '@/components/plugin/UploadFile'; // 上传文件组件
    export default {
        name: 'BatchPicking',// 进口主页
        components: {
            UploadFile
        },
        data() {
            return {
                myDate: {
                    disabledDate(time) {
                        return time.getTime() <= (Date.now() - (24 * 60 * 60 * 1000));
                    }
                },
                siteNavList: [
                    {
                        name: this.$t('message.importBusiness'),
                        link: '/personalCenter/operationCenter/cargoQuery/importBusiness/ActivationCodeLogin',
                        bigData: this.$bigData('importManagement','进口管理','进口管理')
                    },
                    {
                        name: this.$t('message.Ibatchpicking')              
                    }
                ],
                orderBillListLoading: true,
                planDialogLoading: true,
                shwoaccurate: false, // 显示精确提货
                pickupPlanList: [

                ], // 提货计划集合
                accurateOrderBillList: [], // 精确提货集合
                titlePlan: this.$t('message.ICRbatchpicking'),
                drCode: '', // 输入框运单号
                drCodeNumber: '', // 输入框运单号
                planDialogVisible: false, // 新建弹框
                waerhouseDialogVisible: false, // 仓库弹窗
                orderBillList: [], // 获取新建计划的集合
                checked: false,
                cargoType: '',// 判断的类型
                operationWarehouse: '',// 判断的仓库
                customsWarehouseType: '', // 仓储类型
                loadingType: 'sjm',
                loadingBackgroundColor: 'rgba(255,255,255,0.98)',
                actItem: {}, // 选中的对象
                isCreat: true, // 创建数据true 新增false
                accurateOrderBillList1: [], // 添加的集合
                orderBillInfo: {},
                isaccurate: false,// 提货判断类型
                second: false, // 新增判断类型
                first: false, // 创建判断类型
                orderBillListClone1: [],
                orderBillList1: [],
                uploadItme: {}, // 上传时用的对象
                uploadFileVisible: -1,
                pickupPlanId: '',
                modifyItem1: {}, // 修改的原来对象
                modifyItem: { // 修改的新对象
                    pickupRemarks: '',// 提货计划名
                    pickupLicensePlate: '',// 提货车牌号
                    pickupName: '',// 提货人姓名
                    pickupDate: '',// 提货日期（时间戳）
                    pickupPhone: '',// 提货单状态 0-不可开启、1-可开启
                },
                modifyVisible: false, 
                pickupContactList: [], // 车牌号信息集合
            };
        },
        computed: {
            // orderBillList1() {
            //     if (this.drCodeNumber) {
            //         return this.orderBillListClone1.filter(v => v.drCode.includes(this.drCodeNumber));
            //     } else {
            //         console.log(123);
            //         return this.orderBillListClone1;
            //     }
            // }
        },
        watch: {
            drCode(n) {
                if (n.length === 8) {
                    this.getaccurateOrderBillList(); 
                }   
            }
        },
        created() {
            this.getPlan();
            
        },
        methods: {
            // 获取合并提货-提货单的数据
            // getMergePickupPickupBillData() {
            //     this.$ajax({
            //         url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportMergePickupHandler.ashx',
            //         data: {
            //             act: 'getMergePickupPickupBillData',// 获取合并提货-提货单的数据
            //             pickupPlanId: this.modifyItem.pickupPlanId,// 提货计划id
            //         },
            //         beforeSend: () => {
            //         },
            //         success: (res) => {                    
                        
            //         }
            //     });
            // },
            // 输入车牌号匹配默认带出历史
            emailBlurInspect() {
                this.pickupContactList.forEach(i => {
                    if (this.modifyItem.pickupLicensePlate === i.licensePlate) {                 
                        this.modifyItem.pickupName = i.pickupPersonName;
                        this.modifyItem.pickupPhone = i.contact;
                    }
                });
            },
            modify(v) {
                this.modifyItem = JSON.parse(JSON.stringify(v));
                this.modifyItem.pickupDate = this.modifyItem.pickupDate ? new Date(parseInt(this.modifyItem.pickupDate)) : '';
                this.modifyItem1 = JSON.parse(JSON.stringify(v));
                // this.getMergePickupPickupBillData();
                this.modifyVisible = true;

            },
            submitmodify() {
                if (!this.modifyItem.pickupDate) {
                    this.$Message({msg: this.$t('message.b2wkpfa')});
                    return;
                }
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportMergePickupHandler.ashx',
                    data: {
                        act: 'postMergePickupPickupInfoData',// 提交合并提货提货信息的数据
                        pickupPlanId: this.modifyItem.pickupPlanId,// 提货计划id
                        licensePlate: this.modifyItem.pickupLicensePlate,// 车牌号
                        name: this.modifyItem.pickupName,// 提货人姓名
                        contact: this.modifyItem.pickupPhone,// 联系方式
                        remarks: this.modifyItem.pickupRemarks,// 备注
                    },
                    success: () => {
                        this.modifyVisible = false;
                        this.getPlan();
                    }
                }); 
                console.log(this.modifyItem.pickupDate);
                if (this.modifyItem.pickupDate.getTime() !== parseInt(this.modifyItem1.pickupDate)) {
                    window.open('/personalCenter/operationCenter/cargoQuery/importBusiness/SettleAccounts?pickupPlanId=' + this.modifyItem.pickupPlanId + '&pickupDate=' + this.modifyItem.pickupDate.getTime());
                }         
            },
            saveUploadFiles(filesList) {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/FeeHandler.ashx',
                    data: {
                        act: 'postImportPickupUploadFileData',// 提交进口提货上传文件的数据
                        orderBillCode: this.uploadItme.orderBillCode,// 托单号
                        // 客户上传的文件
                        filesList: JSON.stringify(filesList.map(item => item.id)),
                    },
                    success: () => {
                        this.uploadItme.checked = true;
                    }
                });
            },
            filetrOrderBillList() {
                if (this.drCodeNumber) {
                    this.orderBillList1 = this.orderBillListClone1.filter(v => v.drCode.includes(this.drCodeNumber));
                } else {
                    this.orderBillList1 = this.orderBillListClone1;
                }
                
            },
            addTihuo({pickupPlanId}) {
                this.isCreat = false;
                this.pickupPlanId = pickupPlanId;
                this.planDialogVisible = true;
                this.titlePlan = this.$t('message.Iaddingpicking');
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportMergePickupPlanHandler.ashx',
                    data: {
                        act: 'getModifyPickupPlanOrderListData',// 提交新建提货计划的数据
                        pickupPlanId: pickupPlanId,// 提货计划id                         
                    },
                    beforeSend: () => {
                        // 清空时间轴选择项
                        
                        this.planDialogLoading = true;
                    },
                    success: (res) => {
                        let orderBillListClone1 = res.success.orderBillList || [];                     
                        for (let i in orderBillListClone1) {
                            orderBillListClone1[i].checked = false;
                        }
                        this.orderBillListClone1 = orderBillListClone1;
                        this.orderBillList1 = this.orderBillListClone1;

                    },
                    complete: () => {
                        this.planDialogLoading = false;
                    }
                });
            },
            goPage(v) {
                if (v.pickupBillType === '1') {
                    window.open('/personalCenter/operationCenter/cargoQuery/importBusiness/PickUpCargoBatch?pickupPlanId=' + v.pickupPlanId);
                } else {
                    window.open('/personalCenter/operationCenter/cargoQuery/importBusiness/SettleAccounts?pickupPlanId=' + v.pickupPlanId);
                }              
            },
            submitAccurateOrder() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportMergePickupPlanHandler.ashx',
                    data: {
                        act: 'postCreatePickupPlanData',// 提交新建提货计划的数据
                        orderBillCodeList: JSON.stringify(this.accurateOrderBillList1.map(v => v.orderBillCode)),// 托单号列表                          
                    },                 
                    success: (res) => {
                        window.open('/personalCenter/operationCenter/cargoQuery/importBusiness/SettleAccounts?pickupPlanId=' + res.success.pickupPlanId);
                        this.accurateOrderBillList1 = [];
                        this.accurateOrderBillList = [];
                        this.shwoaccurate = false;
                        this.getPlan();
                    }
                   
                });
            },
            submitAddPlan() {
                let orderBillCodeList = this.isCreat ? this.orderBillList.filter(v => v.checked).map(v => v.orderBillCode) : this.orderBillList1.filter(v => v.checked).map(v => v.orderBillCode);
                if (orderBillCodeList.length === 0) {
                    this.$Message({msg: this.$t('message.b1dha1a')});
                    return;
                }
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportMergePickupPlanHandler.ashx',
                    data: {
                        act: this.isCreat ? 'postCreatePickupPlanData' : 'postModifyPickupPlanAddOrderData',// 提交新建提货计划的数据
                        orderBillCodeList: JSON.stringify(orderBillCodeList),// 托单号列表
                        pickupPlanId: this.isCreat ? undefined : this.pickupPlanId,// 提货计划id                          
                    },
                    beforeSend: () => {
                        this.loadingType = 'chrome';
                        this.loadingBackgroundColor = 'transparent';      
                        this.planDialogLoading = true;
                    },
                    success: (res) => {
                        this.planDialogVisible = false;
                        if (this.isCreat) {
                            window.open('/personalCenter/operationCenter/cargoQuery/importBusiness/SettleAccounts?pickupPlanId=' + res.success.pickupPlanId);
                        } else {
                            if (res.success.pickupBillType === '1') {
                                window.open('/personalCenter/operationCenter/cargoQuery/importBusiness/PickUpCargoBatch?pickupPlanId=' + this.pickupPlanId);
                            } else {
                                window.open('/personalCenter/operationCenter/cargoQuery/importBusiness/SettleAccounts?pickupPlanId=' + this.pickupPlanId);
                            }
                        }
                      
                        this.getPlan();
                    },
                    complete: () => {
                        this.planDialogLoading = false;
                        this.loadingType = 'sjm';
                        this.loadingBackgroundColor = 'rgba(255,255,255,0.98)';   
                     
                    }
                });
            },         
            changeChecked(item) {
                if (item.selectCustomsWarehouse === '1') {
                    if (!item.checked) {
                        return;
                    } 
                    item.checked = false;
                    this.first = true; // 新建的
                    this.waerhouseDialogVisible = true;  
                    this.actItem = item;                  
                } else {
                    this.conChecked(item);
                }
                            
            },
            conChecked(item) {
                this.cargoType = item.cargoType;
                this.operationWarehouse = item.operationWarehouse;               
                let oneChecked = this.orderBillList.some(v => v.checked);
                if (!oneChecked) {
                    this.cargoType = '';
                    this.operationWarehouse = '';
                } 
            },
            changeChecked1(item) {
                this.uploadItme = item; // 上传用的item
                
                if (item.needOtherPay === '1') {
                    item.checked = false; // 为false
                    this.$alert(this.$t('message.a1wq1la'), this.$t('message.tip'), {
                        confirmButtonText: this.$t('message.confirm'),
                        showCancelButton: true,
                        callback: action => {
                            if (action === 'confirm') {
                                if (item.selectCustomsWarehouse === '1') {
                                    this.second = true;
                                    this.waerhouseDialogVisible = true;
                                } else if (item.needUplaod === '1') {
                                    this.uploadFileVisible = new Date().getTime();
                                } else {
                                    item.checked = true;
                                }
                                 
                            }  
                        }
                    });                  
                } else if (item.selectCustomsWarehouse === '1') {
                    item.checked = false; // 为false
                    this.second = true;
                    this.waerhouseDialogVisible = true;  
                } else if (item.needUplaod === '1') {
                    item.checked = false; // 为false
                    this.uploadFileVisible = new Date().getTime();
                } 
                            
            },
           
            submitWare() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportMergePickupPlanHandler.ashx',
                    data: {
                        act: 'postImportCustomsWarehouseTypeData',// 获取 进口订单状态节点的数据 
                        orderBillCode: this.first ? this.actItem.orderBillCode : (this.second ? this.uploadItme.orderBillCode : this.orderBillInfo.orderBillCode),// 托单号
                        customsWarehouseType: this.customsWarehouseType,// 海关仓库类型 0-未选择、1-不回流仓库、2-海关扣留、3-物流留场货
                    },              
                    success: () => {
                        if (this.first) {
                            this.actItem.selectCustomsWarehouse = '0';
                            this.actItem.checked = true;
                            this.conChecked(this.actItem); 
                        }
                                         
                        this.waerhouseDialogVisible = false; 
                        if (this.second) {
                            if (this.uploadItme.needUplaod === '1') {
                                this.uploadFileVisible = new Date().getTime();
                            } else {
                                this.uploadItme.checked = true;
                            }
                        }

                        if (this.isaccurate) { // 区分用的
                            this.accurateOrderBillList1.push(this.orderBillInfo);
                        }               
                    }                 
                });
             
            },
          
            getplanList() {
                this.isCreat = true;
                this.titlePlan = this.$t('message.ICRbatchpicking');
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportMergePickupPlanHandler.ashx',
                    data: {
                        act: 'getCreatePickupPlanOrderListData',// 获取 进口订单状态节点的数据                      
                    },
                    beforeSend: () => {
                        // 清空时间轴选择项
                      
                        this.planDialogLoading = true;
                    },
                    success: (res) => {
                        let orderBillList = res.success.orderBillList || [];
                        for (let i in orderBillList) {
                            orderBillList[i].checked = false;                  
                        }
                        this.orderBillList = orderBillList;
                    },
                    complete: () => {
                        this.planDialogLoading = false;
                    }
                });
            },
            initplanList() {                   
                this.orderBillList = [];
                this.orderBillListClone1 = [];
                this.cargoType = '';
                this.operationWarehouse = '';
                this.drCodeNumber = '';
            },
            cargoTypeMeath(type) {
                if (type === '0') {
                    return this.$t('message.generalGoods');
                } else if (type === '1') {
                    return this.$t('message.dangerousGoods');
                } else if (type === '2') {
                    return this.$t('message.coldCollection');
                } else if (type === '5') {
                    return this.$t('message.b5sdbzdasda');
                } else if (type === '8') {
                    return this.$t('message.dangerousColdGoods');
                } else {
                    return '';
                } 
            },
            getPlan() {
                this.isCreat = true;
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportMergePickupPlanHandler.ashx',
                    data: {
                        act: 'getPickupPlanListData',// 获取 进口订单状态节点的数据                      
                    },
                    beforeSend: () => {
                        // 清空时间轴选择项
                      
                        this.orderBillListLoading = true;
                    },
                    success: (res) => {
                        let pickupPlanList = res.success.pickupPlanList || [];
                        for (let i in pickupPlanList) {
                            for (let i1 in pickupPlanList[i].orderBillList) {
                                if (pickupPlanList[i].orderBillList[i1].paymentStatus === '0') {
                                    pickupPlanList[i].paymentStatus = true;
                                    break;
                                }
                            }
                                      
                            
                        }
                        this.pickupPlanList = pickupPlanList;
                        this.pickupContactList = res.success.pickupContactList;// 历史提货联系人
                    },
                    complete: () => {
                        this.orderBillListLoading = false;
                    }
                });
            },
            addaccurateOrder(paramOrderBillCode) {
                let planOrderBillCode = '';
                if (this.accurateOrderBillList1.length > 0) {
                    if (this.accurateOrderBillList1.some(v => v.orderBillCode === paramOrderBillCode)) {
                        this.$alert(this.$t('message.c1fffa'),this.$t('message.tip')); 
                        return;
                    } else {
                        planOrderBillCode = this.accurateOrderBillList1[0].orderBillCode;
                    }                 
                }
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportMergePickupPlanHandler.ashx',
                    data: {
                        act: 'getCreatePickupPlanExactOrderData',// 获取新建提货计划确切订单的数据
                        orderBillCode: paramOrderBillCode, // 添加的托单号
                        planOrderBillCode: planOrderBillCode, // 提货计划中的托单号                              
                    },                
                    success: (res) => {
                        let orderBillInfo = res.success.orderBillInfo || {};
                        if (orderBillInfo.selectCustomsWarehouse === '1') {
                            this.orderBillInfo = orderBillInfo;
                            this.waerhouseDialogVisible = true;
                            this.isaccurate = true;
                        } else {
                            this.accurateOrderBillList1.push(orderBillInfo);
                        }
                    },
                  
                });
            },
            getaccurateOrderBillList() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportMergePickupPlanHandler.ashx',
                    data: {
                        act: 'getCreatePickupPlanExactOrderPreData',// 获取 进口订单状态节点的数据 
                        drCode: this.drCode,// 主运单号（精确搜索后8位、纯运单号搜订单、不做添加计划的check）                     
                    },                
                    success: (res) => {
                        this.accurateOrderBillList = res.success.orderBillList || [];
                        if (this.accurateOrderBillList.length === 0) {
                            this.$alert(this.$t('message.b5sdbra'),this.$t('message.tip')); 
                        }
                    },
                  
                });
            },
            deleteacc(i) {
                this.$alert(this.$t('message.b4wdqda'), this.$t('message.tip'), {
                    confirmButtonText: this.$t('message.confirm'),                  
                    showCancelButton: true,
                    callback: action => {
                        if (action === 'confirm') {
                            this.accurateOrderBillList1.splice(i,1); 
                        }  
                    }
                }); 
            },
            deletePlan(orderBillCode) {
                this.$alert(this.$t('message.b4wdqda'), this.$t('message.tip'), {
                    confirmButtonText: this.$t('message.confirm'),                  
                    showCancelButton: true,
                    callback: action => {
                        if (action === 'confirm') {
                            this.$ajax({
                                url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportMergePickupPlanHandler.ashx',                            
                                data: {
                                    act: 'postDelPickupPlanOrderData',// 提交删除提货计划订单的数据
                                    orderBillCode: orderBillCode,// 托单号                                             
                                },                
                                success: () => {
                                    this.getPlan();                                  
                                }
                            
                            });
                        }  
                    }
                }); 
            }
        },
    };
</script>
<style lang="scss" scoped>
    .batchPicking {
        min-width: 1245px;
        overflow: hidden;
        background-color: #f3f3f4;

        .container {
            position: relative;
            width: 1245px;
            margin: 0 auto;

            .siteNav {
                width: 1245px;
                margin: 0 auto;
            }

            // 模板确认
            .templateSettings {
                width: 114px;
                height: 44px;
                padding-left: 22px;
                margin-bottom: 12px;
                line-height: 44px;
                color: #0aa7ee;
                cursor: pointer;
                background-color: #fff;
                background-image: url('~@/assets/img/personalCenter/operationCenter/cargoQuery/importBusiness/setUp.png');
                background-repeat: no-repeat;
                background-position: 10px 14px;
                border: none;
            }

            .modmodal {
                /deep/ .el-dialog__body {
                    padding-bottom: 5px;
                }
            }

            .mody {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 10px;
            }

            .batchPicking-container {
                min-height: 600px;
                background: #fff;

                .searchWrap {
                    position: relative;
                    display: flex;
                    padding-top: 20px;
                    margin-left: 20px;

                    .conditionInput {
                        width: 130px;
                        margin-right: 12px;
                    }

                    .arrivalDate {
                        margin-right: 10px;
                    }

                    .opeartingBtn {
                        margin-left: 15px;
                    }
                }

                .plan-data {
                    position: relative;
                    min-height: 300px;
                    margin-top: 20px;

                    .orderBillList {
                        width: 100%;
                        margin-top: 20px;

                        th {
                            padding-bottom: 8px;
                            font-size: 16px;
                            font-weight: normal;
                            color: #575757;
                        }

                        .titleBox {
                            box-sizing: border-box;
                            display: flex;
                            width: 100%;
                            padding: 0 1px;

                            .ticket {
                                display: flex;
                                align-items: center;
                                margin-top: -2px;

                                .paperMoney {
                                    display: flex;
                                    width: 10px;
                                }
                            }

                            .tit {
                                text-align: center;

                                .iconfont {
                                    display: inline-block;
                                    font-size: 12px;
                                }

                                .jiantou3 {
                                    display: inline-block;
                                }

                                .up {
                                    margin-left: 5px;
                                    color: #00a7f7;
                                    cursor: pointer;
                                }

                                .down {
                                    margin-left: 5px;
                                    color: #00a7f7;
                                    cursor: pointer;
                                }
                            }
                        }

                        .contentTr {
                            height: 75px;

                            &.active {
                                cursor: default;

                                .flightInfoBox {
                                    background-color: #deedff;
                                    border: 1px solid #deedff;
                                    box-shadow: 0 2px 4px 0 rgba(152, 152, 152, 0.52);
                                }

                                .dash {
                                    background-color: #deedff;
                                    box-shadow: 0 2px 4px 0 rgba(152, 152, 152, 0.52);
                                }

                                .strip {
                                    background-color: #deedff;
                                    border: 1px solid #deedff;
                                    box-shadow: 0 2px 4px 0 rgba(152, 152, 152, 0.52);
                                }
                            }

                            .flightInfoBox {
                                position: relative;
                                box-sizing: border-box;
                                display: flex;
                                align-items: center;
                                width: 100%;
                                height: 60px;
                                border: 1px solid #979797;
                                border-radius: 4px;
                                transition: 0.25s all;

                                .airlineBox {
                                    display: flex;
                                    align-items: center;
                                    width: 44px;
                                    height: 44px;
                                    margin-right: 7px;
                                    margin-left: 8px;
                                    overflow: hidden;
                                    border-radius: 50%;

                                    .airlineImg {
                                        width: 100%;
                                        height: 100%;
                                    }
                                }

                                .infoBox {
                                    position: relative;
                                    height: 100%;

                                    .flightTxt {
                                        margin-bottom: 7px;
                                        font-size: 16px;
                                        color: #4a4a4a;
                                        text-align: left;

                                        &.notFlight {
                                            margin-top: 5px;
                                            margin-bottom: 7px;
                                            font-size: 12px;
                                            color: #bbb;
                                        }
                                    }

                                    .dateBox {
                                        display: flex;
                                        align-items: center;

                                        .day {
                                            position: relative;
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                            width: 22px;
                                            height: 22px;
                                            margin-right: 3px;
                                            border: 1px solid #575757;
                                            border-radius: 3px;

                                            &::before {
                                                position: absolute;
                                                top: -3px;
                                                left: 6px;
                                                width: 2px;
                                                height: 4px;
                                                content: '';
                                                background: #575757;
                                            }

                                            &::after {
                                                position: absolute;
                                                top: -3px;
                                                right: 6px;
                                                width: 2px;
                                                height: 4px;
                                                content: '';
                                                background: #575757;
                                            }
                                        }

                                        .month {
                                            font-size: 16px;
                                            color: #4a4a4a;
                                        }
                                    }
                                }
                            }

                            .dash {
                                display: inline-block;
                                width: 30px;
                                height: 4px;
                                background-color: #bbb;
                                transition: 0.25s all;
                            }

                            .strip {
                                position: relative;
                                box-sizing: border-box;
                                display: flex;
                                width: 100%;
                                min-height: 60px;
                                border: 1px solid #979797;
                                border-radius: 4px;
                                transition: 0.25s all;

                                .notVipIcon {
                                    position: absolute;
                                    top: -2px;
                                    left: -5px;
                                    padding: 2px 5px;
                                    font-size: 10px;
                                    color: white;
                                    background: #d8d8d8 linear-gradient(6deg, #71d1ff 0%, #00a7f7 100%);
                                    border-radius: 4px 0 9px 0;
                                    transform: scale(0.8);
                                }

                                .notmonthly {
                                    position: absolute;
                                    top: -2px;
                                    left: -5px;
                                    width: 25px;
                                    height: 18px;
                                    padding: 2px 5px;
                                    font-size: 10px;
                                    color: white;
                                    background: #f4b01c;
                                    border-radius: 4px 0 9px 0;
                                    transform: scale(0.8);
                                }

                                .stripItem {
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;

                                    .electronicInvoiceDown {
                                        display: block;
                                        font-size: 12px;
                                        color: #409eff;
                                    }

                                    .invoiceTextStyle {
                                        color: #c0c4cc;
                                        cursor: not-allowed;
                                    }

                                    &.goldenColor {
                                        justify-content: flex-end;
                                        color: #f4b01c;
                                        text-align: right;
                                    }

                                    .warehouseRed {
                                        color: #e73828;
                                    }

                                    .orderCloud {
                                        position: relative;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        width: 40px;
                                        height: 40px;
                                        cursor: pointer;
                                        background-color: #00a7f7;
                                        border-radius: 50%;
                                        box-shadow: 2px 2px 6px 0 rgba(0, 0, 0, 0.06), -2px -2px 4px 0 rgba(0, 0, 0, 0.06);

                                        i.iconfont {
                                            font-size: 20px;
                                            color: white;
                                        }

                                        &.down {
                                            background-color: white;

                                            i.iconfont {
                                                color: #00a7f7;
                                            }
                                        }
                                    }

                                    .icon {
                                        font-size: 28px;
                                        color: #00a7f7;
                                        cursor: pointer;
                                    }

                                    .insuranceIcon {
                                        margin-left: 4px;
                                    }

                                    .icon-shanchu {
                                        font-size: 24px;
                                        color: #00a7f7;
                                        cursor: pointer;
                                    }
                                }

                                .readType {
                                    position: absolute;
                                    top: 17px;
                                    left: 435px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

</style>

